export default defineNuxtRouteMiddleware(() => {
  if (process.server) return

  const config = useRuntimeConfig().public

  if (config.appEnv === 'test') return

  localStorage.setItem('flow', 'Sign in') // default flow

  const analytics = useAnalytics()
  // TODO: We should change this middleware to a plugin after we upgrade from Nuxt 3.5 to 3.8 since they already solved an issue related to layers.
  // https://github.com/nuxt/nuxt/pull/23148
  analytics.page()
})
